import { useLang } from "@/context/LanguageContext";
import { useBranch } from "@/context/BranchContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Car, ChefHat } from "lucide-react";

export default function BranchSelectorModal({ open, onOpenChange, forceChoice = false }) {
  const { lang, t } = useLang();
  const { setBranchType, branchType } = useBranch();

  const pick = (v) => {
    setBranchType(v);
    onOpenChange?.(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        // If forceChoice (first visit and no selection), disallow closing without picking
        if (!next && forceChoice && !branchType) return;
        onOpenChange?.(next);
      }}
    >
      <DialogContent
        className="max-w-lg bg-[#FDFBF7] rounded-3xl border-0 p-0 overflow-hidden"
        data-testid="branch-selector-modal"
      >
        <div className="bg-[#0F5F63] text-[#FDFBF7] px-8 py-8 grain">
          <p className="text-[10px] uppercase tracking-[0.35em] opacity-80">
            {lang === "ar" ? "قبل أن تبدأ" : "Before you start"}
          </p>
          <DialogHeader className="mt-3 space-y-1">
            <DialogTitle
              className={`${lang === "ar" ? "font-serif-ar text-end" : "font-serif-en"} text-3xl lg:text-4xl leading-tight`}
            >
              {t.branchSelectTitle}
            </DialogTitle>
          </DialogHeader>
          <p className="mt-3 text-sm opacity-80 leading-relaxed">
            {t.branchSelectHint}
          </p>
        </div>

        <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <button
            type="button"
            onClick={() => pick("full")}
            data-testid="branch-choice-full"
            className={`group text-start p-6 rounded-2xl border transition-all ${
              branchType === "full"
                ? "border-[#0F5F63] bg-[#0F5F63]/5"
                : "border-black/10 hover:border-[#0F5F63] hover:bg-[#F4F2EB]"
            }`}
          >
            <div className="w-12 h-12 rounded-full bg-[#0F5F63]/10 flex items-center justify-center text-[#0F5F63] mb-4 group-hover:scale-105 transition-transform">
              <ChefHat className="w-6 h-6" />
            </div>
            <p className={`${lang === "ar" ? "font-serif-ar" : "font-serif-en"} text-xl text-[#0F5F63] font-semibold`}>
              {t.branchFull}
            </p>
            <p className="text-xs text-[#5C6B6D] mt-2 leading-relaxed">
              {t.branchFullHint}
            </p>
          </button>

          <button
            type="button"
            onClick={() => pick("drivethru")}
            data-testid="branch-choice-drivethru"
            className={`group text-start p-6 rounded-2xl border transition-all ${
              branchType === "drivethru"
                ? "border-[#0F5F63] bg-[#0F5F63]/5"
                : "border-black/10 hover:border-[#0F5F63] hover:bg-[#F4F2EB]"
            }`}
          >
            <div className="w-12 h-12 rounded-full bg-[#E27B58]/15 flex items-center justify-center text-[#E27B58] mb-4 group-hover:scale-105 transition-transform">
              <Car className="w-6 h-6" />
            </div>
            <p className={`${lang === "ar" ? "font-serif-ar" : "font-serif-en"} text-xl text-[#0F5F63] font-semibold`}>
              {t.branchDriveThru}
            </p>
            <p className="text-xs text-[#5C6B6D] mt-2 leading-relaxed">
              {t.branchDriveThruHint}
            </p>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
